import { useState } from 'react';
import { Button, PageHeader } from '@flos/react-ui';
import CallMeModal from '../../../shared_components/CallMeModal/CallMeModal';
import { useHippoText } from '../../../hooks/useHippoText';
import type { WizardPageComponent } from '../../../config/wizardPagesConfig';
import { useRecoilValue } from 'recoil';
import { topConfigContextAtom } from '../../../recoil/atoms/topConfigContextAtom';

const QuoteExpiredContent: WizardPageComponent = () => {
    const [showModal, setShowModal] = useState(false);
    const getHippoText = useHippoText();
    const topConfigContext = useRecoilValue(topConfigContextAtom);

    return (
        <PageHeader
            title={getHippoText('DSS-EXPIRED-QUOTE-PAGE-HEADER')}
            subtitle={
                <p className="paragraph--large">
                    {getHippoText('DSS-EXPIRED-QUOTE-PAGE-SUBHEADER')}
                </p>
            }
            imageUrl={`${topConfigContext?.resourceUrl ?? ''}/images/man-sad-phone.svg`}
        >
            <div>
                <Button
                    onClick={() => {
                        setShowModal(true);
                    }}
                    theme="primary"
                    minWidth="widest"
                >
                    {getHippoText('DSS-COMMON-CALL-ME')}
                </Button>
                {showModal && (
                    <CallMeModal
                        activityCode="dss_call_request"
                        showModal={showModal}
                        closeModal={() => {
                            setShowModal(false);
                        }}
                    />
                )}
            </div>
        </PageHeader>
    );
};

export default QuoteExpiredContent;
